import { useEffect, useState } from 'react';
import { isLive, request, signOut } from './client.ts';
import { me as mockMe } from '../mock.ts';

/**
 * 로그인한 사람.
 *
 * 화면에 이름이 필요한 자리는 C2·C4 의 '작성자' 한 줄이고, 노트에 들어 있는
 * authorId 는 UUID 라 그대로 보여 줄 수 없습니다 — 사람이 읽을 이름은
 * 여기서만 옵니다.
 *
 * **식별자도 함께 내보냅니다.** 모임 기록지가 «내 줄인가»를 가려야 하는데
 * (화면 F4 의 「나」 꼬리표), 그 판단에 쓸 내 식별자가 여기밖에 없습니다.
 *
 * 이름을 못 받아도 화면이 멈추면 안 되므로, 실패하면 조용히 '나'로 둡니다.
 * 노트가 저장되는지와는 상관없는 값입니다.
 */

interface Payload {
  user: { userId: string; name: string | null };
}

export function useMe(): { name: string; userId: string | null } {
  const live = isLive();
  const [name, setName] = useState(live ? '나' : mockMe.name);
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    if (!live) return;

    let alive = true;
    request<Payload>('/me')
      .then((res) => {
        if (!alive) return;
        if (res.user.name) setName(res.user.name);
        setUserId(res.user.userId);
      })
      .catch(() => {
        /* 이름이 없어도 노트는 쓸 수 있습니다 */
      });

    return () => {
      alive = false;
    };
  }, [live]);

  return { name, userId };
}

/**
 * 계정 지우기 — 앱스토어 심사 지침 5.1.1(v).
 *
 * 계정을 만드는 앱은 **앱 안에서** 지울 수 있어야 합니다. 메일로 요청하게
 * 두면 반려됩니다.
 *
 * 성공하면 토큰도 함께 버립니다 — 지워진 계정의 토큰을 들고 있으면 다음
 * 요청마다 401 을 받습니다.
 */
export async function deleteAccount(): Promise<void> {
  await request<void>('/me', { method: 'DELETE' });
  signOut();
}
